import { useRegisterCommands } from "components/Layout/Panels/VSCode/useRegisterCommands";
import { useBranchEditor } from "features/editor/Feature";

import { createRegistrator } from "commands/register";

import { useForkBranchCommand } from "../definitions/branch/useForkCommand";

const useRegisterBranchCreatorCommands = (): void => {
  const { defaultBranchName } = useBranchEditor();

  const createDraftBranchFromCurrent = useForkBranchCommand({
    target: "CURRENT",
  });

  const createDraftBranchFromDefault = useForkBranchCommand({
    target: "DEFAULT",
  });

  useRegisterCommands(
    [
      {
        id: "codesandbox.git.createDraftBranchFromDefault",
        section: "Git",
        name: `Create Draft Branch from '${defaultBranchName}'`,
        perform: createDraftBranchFromDefault.perform,
      },
      {
        id: "codesandbox.git.createDraftBranchFromCurrent",
        name: "Create Draft Branch from Current",
        section: "Git",
        perform: createDraftBranchFromCurrent.perform,
      },
    ],
    [],
  );
};

export const RegisterBranchCreatorCommands = createRegistrator(
  useRegisterBranchCreatorCommands,
);
